import { Component } from '@angular/core';
import { MatToolbar } from '@angular/material/toolbar';
import { RouterOutlet } from '@angular/router';

import { TranslatePipe } from '@next/core-lib/i18n';

import { ThirdPartiesNavigationComponent } from '../third-parties-navigation/third-parties-navigation.component';

@Component({
  selector: 'app-third-parties-overview',
  templateUrl: 'third-parties-overview.component.html',
  imports: [MatToolbar, ThirdPartiesNavigationComponent, RouterOutlet, TranslatePipe],
})
export class ThirdPartiesOverviewComponent {
  getState = (outlet: RouterOutlet) => outlet.isActivated && outlet.activatedRoute.routeConfig.data;

  constructor() {}
}
